exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:767px){\r\n    .smart-padding{\r\n        padding:0;\r\n        min-width: 33%;\r\n    }\r\n    .mat-list-item .col-md-6{\r\n        min-width: 33%;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/distinta-contanti.component.css
// module id = ../../../../../src/app/components/incassi/distinta-contanti.component.css
// module chunks = main